module.exports = __webpack_public_path__ + "static/media/AutoCAD Map 3D.acc45d15.png";